import AxiosConfig from '../config/axiosConfigApiPlataform'

export const PlataformFaculdadeApi = {
  async get () {
    let response = await AxiosConfig.api().get('listarFaculdade')
    return response.data
  },

}

export default PlataformFaculdadeApi
